module.exports = __webpack_public_path__ + "static/etudes-b442b6a31b0248aac676408dbbd4fb2c.jpg";